import React from 'react';

import BehavioralData from '../../components/Animations/BehavioralData/BehavioralData';
import ComparisonTable from '../../components/Common/ComparisonTable';
import Drawer from '../../components/Common/Drawer';
import MasonryGrid from '../../components/Common/MasonryGrid';
import Reviews from '../../components/Common/Reviews';
import ScrollAnimation from '../../components/Common/ScrollAnimation';
import Cards from '../../components/Common/SideScroll/Cards';
import ManualSideScroll from '../../components/Common/SideScroll/ManualSideScroll';
import SideScroll from '../../components/Common/SideScroll/SideScroll';
import Slider from '../../components/Common/Slider';
import TabbedCustomerStories from '../../components/Common/TabbedCustomerStories';
import Tabs from '../../components/Common/Tabs';
import AnimatedRow from '../../components/HomePage/AnimatedRow';
import GroupedContent from '../../components/PageSections/GroupedContent';
import ThreeUp from '../../components/PageSections/ThreeUp';

export const ContentfulSectionGroupedItems = (page, section, i, styles, isCampaignLP) => {
  if (section.type === 'Logo List') {
    return <AnimatedRow key={i} heading={section.heading} logos={section.content} />;
  }
  // TODO: This is a confusing check and needs to be addressed
  // * Context: We currently have two styles of the Three Up module.
  // * We're using the check below to determine when to render the
  // * newer animated version with the gradient bg color.
  if (section.backgroundColor && section.type === 'Three Up') {
    let bgColor;
    switch (section.backgroundColor) {
      case 'Blue Gradient':
        bgColor = 'blueGradient';
        break;
      case 'Spark Gradient': {
        bgColor = 'sparkGradient';
        break;
      }
      case 'Purple Gradient': {
        bgColor = 'purpleGradient';
        break;
      }
      case 'Evergreen': {
        bgColor = 'evergreen';
        break;
      }
      default:
        break;
    }
    return <ThreeUp section={section} animate key={i} className={styles[bgColor]} />;
  }
  if (section.type === 'Comparison Table') {
    return <ComparisonTable key={i} section={section} />;
  }
  if (section.type === 'Hardcoded Animation') {
    return section.animationType === 'Behavioral Data' ? (
      <BehavioralData key={i} content={section.content} />
    ) : (
      <ScrollAnimation key={i} section={section} />
    );
  }
  if (section.type === 'Masonry Grid') {
    return (
      <MasonryGrid key={i} title={section.title} content={section.content} backgroundColor={section.backgroundColor} />
    );
  }
  if (section.type === 'Reviews') {
    return <Reviews key={i} content={section.content} backgroundColor={section.backgroundColor} />;
  }
  if (section.type === 'Side Scroll') {
    return section.scrollingContentType === 'cards' ? (
      <ManualSideScroll key={i}>
        <Cards content={section.content} cardIsClickable={false} />
      </ManualSideScroll>
    ) : (
      <SideScroll key={i} section={section} />
    );
  }
  if (section.type === 'Drawer') {
    return <Drawer key={i} section={section} />;
  }
  if (section.type === 'Tabbed Customer Stories') {
    return <TabbedCustomerStories key={i} section={section} />;
  }
  if (section.type === 'Slider') {
    return <Slider key={i} section={section} />;
  }
  if (section.type === 'Tabs') {
    return <Tabs key={i} section={section} />;
  }
  return (
    <GroupedContent
      key={i}
      section={section}
      i={i}
      noPad={isCampaignLP}
      wide={isCampaignLP}
      fullImage={isCampaignLP}
      forceNewTab={isCampaignLP}
      colorTheme={page.colorTheme}
    />
  );
};
